export function diffDate(first, sec = new Date()) {
    // deffrent time in days between two times where the secound parameter is the previously time
    return Math.floor((first - sec) / 86400000);
}

export function dateFormater(date) {
    return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short', }).format(date);
}
export function dateFormaterJustDate(date) {
    return new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short' }).format(date);
}

export function getDay(date) {
    return new Intl.DateTimeFormat('ar-SY', { weekday: 'long' }).format(date);
}

export function getMonth(date) {
    return new Intl.DateTimeFormat('ar-SY', { month: 'long' }).format(date);
}